var _rect, _path, _path2, _mask, _path3, _path4, _path5, _path6, _circle, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4062 30.0029C20.4062 26.6892 23.0925 24.0029 26.4062 24.0029H82.292C85.6057 24.0029 88.292 26.6892 88.292 30.0029V77.9686C88.292 81.2824 85.6057 83.9686 82.292 83.9686H26.4062C23.0925 83.9686 20.4062 81.2824 20.4062 77.9686V30.0029Z",
    fill: "white",
    stroke: "#044E97",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7188 41.3184C31.7188 38.0047 34.405 35.3184 37.7188 35.3184H93.6045C96.9182 35.3184 99.6045 38.0047 99.6045 41.3184V89.2841C99.6045 92.5978 96.9182 95.2841 93.6045 95.2841H37.7187C34.405 95.2841 31.7188 92.5978 31.7188 89.2841V41.3184Z",
    fill: "white",
    stroke: "#044E97",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_51509_59928",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.08 61.1035C83.08 64.7224 80.1462 67.6561 76.5273 67.6561C72.9083 67.6561 69.9746 64.7224 69.9746 61.1035C69.9746 57.4845 72.9083 54.5508 76.5273 54.5508C80.1462 54.5508 83.08 57.4845 83.08 61.1035ZM70.7992 71.1396C66.1595 71.1396 62.3984 74.9008 62.3984 79.5405C62.3984 80.9324 63.5268 82.0608 64.9187 82.0608H88.2731C89.665 82.0608 90.7934 80.9324 90.7934 79.5405C90.7934 74.9008 87.0323 71.1396 82.3926 71.1396H76.5959H70.7992Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5273 69.6561C81.2508 69.6561 85.08 65.827 85.08 61.1035H81.08C81.08 63.6178 79.0417 65.6561 76.5273 65.6561V69.6561ZM67.9746 61.1035C67.9746 65.827 71.8038 69.6561 76.5273 69.6561V65.6561C74.0129 65.6561 71.9746 63.6178 71.9746 61.1035H67.9746ZM76.5273 52.5508C71.8038 52.5508 67.9746 56.3799 67.9746 61.1035H71.9746C71.9746 58.5891 74.0129 56.5508 76.5273 56.5508V52.5508ZM85.08 61.1035C85.08 56.3799 81.2508 52.5508 76.5273 52.5508V56.5508C79.0417 56.5508 81.08 58.5891 81.08 61.1035H85.08ZM64.3984 79.5405C64.3984 76.0054 67.2641 73.1396 70.7992 73.1396V69.1396C65.0549 69.1396 60.3984 73.7963 60.3984 79.5405H64.3984ZM64.9187 80.0608C64.6314 80.0608 64.3984 79.8279 64.3984 79.5405H60.3984C60.3984 82.037 62.4222 84.0608 64.9187 84.0608V80.0608ZM88.2731 80.0608H64.9187V84.0608H88.2731V80.0608ZM88.7934 79.5405C88.7934 79.8279 88.5604 80.0608 88.2731 80.0608V84.0608C90.7696 84.0608 92.7934 82.037 92.7934 79.5405H88.7934ZM82.3926 73.1396C85.9277 73.1396 88.7934 76.0054 88.7934 79.5405H92.7934C92.7934 73.7963 88.1369 69.1396 82.3926 69.1396V73.1396ZM76.5959 73.1396H82.3926V69.1396H76.5959V73.1396ZM70.7992 73.1396H76.5959V69.1396H70.7992V73.1396Z",
    fill: "#044E97",
    mask: "url(#path-4-inside-1_51509_59928)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2609 56.1217C67.2609 60.7361 63.5202 64.4768 58.9059 64.4768C54.2915 64.4768 50.5508 60.7361 50.5508 56.1217C50.5508 51.5073 54.2915 47.7666 58.9059 47.7666C63.5202 47.7666 67.2609 51.5073 67.2609 56.1217ZM51.6256 68.9121C45.7097 68.9121 40.9141 73.7079 40.9141 79.6237C40.9141 81.3985 42.3528 82.8372 44.1276 82.8372H73.9059C75.6807 82.8372 77.1194 81.3985 77.1194 79.6237C77.1194 73.7079 72.3237 68.9121 66.4079 68.9121H59.0167H51.6256Z",
    fill: "#044E97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5631 95.1279C16.4798 95.1279 15.6016 94.2497 15.6016 93.1664V93.1664C15.6016 92.0831 16.4798 91.2049 17.5631 91.2049L24.0669 91.2049C25.1502 91.2049 26.0284 92.0831 26.0284 93.1664V93.1664C26.0284 94.2497 25.1502 95.1279 24.0669 95.1279L17.5631 95.1279Z",
    stroke: "#044E97",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.296 22.4863C102.38 22.4863 103.258 23.3645 103.258 24.4478V24.4478C103.258 25.5311 102.38 26.4093 101.296 26.4093L94.7925 26.4093C93.7092 26.4093 92.831 25.5311 92.831 24.4478V24.4478C92.831 23.3645 93.7092 22.4863 94.7925 22.4863L101.296 22.4863Z",
    stroke: "#044E97",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5922,
    cy: 32.4027,
    r: 15.6,
    fill: "white",
    stroke: "#044E97",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7891 24.6008C25.7891 23.6067 26.595 22.8008 27.5891 22.8008V22.8008C28.5832 22.8008 29.3891 23.6067 29.3891 24.6008V31.8008C29.3891 32.7949 28.5832 33.6008 27.5891 33.6008V33.6008C26.595 33.6008 25.7891 32.7949 25.7891 31.8008V24.6008Z",
    stroke: "#044E97",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7891 40.198C25.7891 41.1922 26.595 41.998 27.5891 41.998V41.998C28.5832 41.998 29.3891 41.1922 29.3891 40.198V40.198C29.3891 39.2039 28.5832 38.398 27.5891 38.398V38.398C26.595 38.398 25.7891 39.2039 25.7891 40.198V40.198Z",
    stroke: "#044E97",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNotFound);
export default __webpack_public_path__ + "static/media/UserNotFound.9bc4968787bb6f85317926443e3988c7.svg";
export { ForwardRef as ReactComponent };